export const MAX_WELCOME_SUGGESTIONS = 6;
// Floors, not exact counts: mirror the breakpoint classes in welcome.tsx and the container-height
// rules in styles/components.css, which show a 3rd and 4th tile on tall viewports at any width.
export const WIDGET_VISIBLE_STARTERS = 2;
export const MEDIUM_VISIBLE_STARTERS = 4;

export function hasDateWindow({ from, until }: { from?: string; until?: string }): boolean {
  return Boolean(from || until);
}

/**
 * Which starters the welcome screen fixes in place, in list order, and how many slots it fills at
 * random from `pool`. Rotation off: the first ones, nothing random. Rotation on: pinned ones first
 * (at most the maximum), the rest are the pool.
 */
export function planWelcomeStarters<T extends { pinned?: boolean }>({
  starters,
  isRotating,
}: {
  starters: T[];
  isRotating: boolean;
}): { fixed: T[]; pool: T[]; randomSlots: number } {
  if (!isRotating) {
    return { fixed: starters.slice(0, MAX_WELCOME_SUGGESTIONS), pool: [], randomSlots: 0 };
  }
  const fixed = starters.filter(starter => starter.pinned).slice(0, MAX_WELCOME_SUGGESTIONS);
  const pool = starters.filter(starter => !starter.pinned);
  const randomSlots = Math.min(MAX_WELCOME_SUGGESTIONS - fixed.length, pool.length);
  return { fixed, pool, randomSlots };
}
